import React from 'react'
import style from '../style.scss'

export const StatusBar = () => {
    return <>
        <footer className={style.statusBar}>
            <div className={style.item}>
                <span>{window.APP_VERSION}</span>
                <span className={style.botName}></span>
                {/* <LangSwitcher languages={languages}></LangSwitcher> */}
            </div>
            <div className={style.item}></div>
        </footer>
    </>
}
